import axios from 'axios';
import { API_URL } from '../data/costant';

const axiosInstance = axios.create({
  baseURL: API_URL
});

export default axiosInstance;